import gql from 'graphql-tag';

const renewMember = gql`
mutation renewMember($member: MemberInput) {
  renewMember(input: $member) {
    id
    personId
    firstName
    middleName
    lastName
    phoneNumber
    addressLine1
    addressLine2
    city
    state
    zipCode
    country
    emailAddress
    birthMonth
    birthDay
    birthYear
    spouseFirstName
    spouseMiddleName
    spouseLastName
    spouseBirthMonth
    spouseBirthDay
    spouseBirthYear
    spouseEmailAddress
    spouseId
    spanishMaterial
    accountIndicator
    accountType
    accountStatus
    expiryDate
    autoRenew
    membershipTerm
    cardSentDate
  }
}
`;

export default renewMember;



// WEBPACK FOOTER //
// ./src/app/mutations/renewMember.js